import * as React from "react";
const SvgMenu = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3 18h18v-2H3zm0-5h18v-2H3zm0-7v2h18V6z" }));
export default SvgMenu;
